<script lang="ts">
  import { api, ApiError, OfflineError } from '../lib/api'
  import { session } from '../lib/session.svelte'
  import { router } from '../lib/router.svelte'
  import { ripple } from '../lib/ripple'
  import Notice from '../lib/components/Notice.svelte'

  let email = $state('')
  let password = $state('')
  let rememberMe = $state(false)
  let busy = $state(false)
  let error = $state<string | null>(null)

  async function submit(event: SubmitEvent) {
    event.preventDefault()
    if (busy) return
    busy = true
    error = null
    try {
      // Trimmed and lowercased before it leaves, matching what AuthenticationController has always done —
      // otherwise a copied-and-pasted address with a trailing space is an unexplainable wrong password.
      const result = await api.signIn(email.trim().toLowerCase(), password.trim())
      session.remember(result, rememberMe)
      router.resume()
    } catch (e) {
      // ONE MESSAGE for a wrong address and a wrong password alike. Telling somebody the address was not
      // found turns this form into a way to discover who has an account.
      if (e instanceof ApiError && e.status === 401) error = 'Invalid email or password.'
      else if (e instanceof OfflineError) error = 'Could not reach Bird Journal. Check your connection and try again.'
      else error = 'Something went wrong signing you in. Please try again.'
    } finally {
      busy = false
    }
  }
</script>

{#if error}
  <Notice tone="error">{error}</Notice>
{/if}

<form onsubmit={submit} novalidate>
  <div class="field">
    <label class="field-label" for="email">Email address</label>
    <div class="sfield">
      <input
        id="email"
        type="email"
        bind:value={email}
        autocomplete="username"
        inputmode="email"
        spellcheck="false"
        required
      />
    </div>
  </div>

  <div class="field">
    <label class="field-label" for="password">Password</label>
    <div class="sfield">
      <input id="password" type="password" bind:value={password} autocomplete="current-password" required />
    </div>
  </div>

  <label class="choice remember">
    <input type="checkbox" bind:checked={rememberMe} />
    <span>Keep me signed in on this device</span>
  </label>

  <button class="btn btn-accent rip submit" use:ripple type="submit" disabled={busy}>
    {busy ? 'Signing in…' : 'Sign in'}
  </button>

  <p class="alt"><a href="/forgot-password">Forgotten your password?</a></p>
</form>

<style>
  .remember {
    margin: var(--space-4) 0 var(--space-5);
  }
  .submit {
    width: 100%;
  }
  .alt {
    margin: var(--space-5) 0 0;
    text-align: center;
    font-size: 0.95rem;
  }
</style>
